// import React from 'react';
import ReactDOM from 'react-dom/client'
import App from './App'
import {store, persister} from './store'
import {PersistGate} from 'redux-persist/es/integration/react'
import {Provider} from 'react-redux'
import {Chart, registerables} from 'chart.js'

/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import 'assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import 'assets/css/style.rtl.css'
 **/
import 'react-phone-input-2/lib/style.css'
import 'assets/sass/style.scss'
import 'assets/sass/style.react.scss'
import 'react-toastify/dist/ReactToastify.css'
import 'react-datepicker/dist/react-datepicker.css'

/* eslint-disable no-undef */
const {PUBLIC_URL} = process.env

Chart.register(...registerables)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persister}>
      <App basename={PUBLIC_URL} />
    </PersistGate>
  </Provider>
  // </React.StrictMode>
)
